import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { LogsComponent } from './components/logs/logs.component';
import { SmsLogsComponent } from './components/sms-logs/sms-logs.component';
import { MyDateRangePickerModule } from 'mydaterangepicker';
import { MailLogsComponent } from './components/mail-logs/mail-logs.component';

@NgModule({
  imports: [
    SharedModule,
    RouterModule,
    NgxDatatableModule,
    MyDateRangePickerModule
  ],
  declarations: [
    LogsComponent,
    SmsLogsComponent,
    MailLogsComponent
  ]
})
export class LogsModule { }



// WEBPACK FOOTER //
// ./src/app/logs/logs.module.ts